import { call, put } from 'redux-saga/effects';

import {
  getUserFail,
  getUserStart,
  getUserSuccess,
  getUserTagsError,
  getUserTagsSuccess,
} from '@/store/actions/user';
import BffApiService from '@/shared/bffApiService';

export function* getUserSaga() {
  yield put(getUserStart());

  try {
    const response = yield call(BffApiService.getUser);
    yield put(getUserSuccess(response.data.data));
  } catch (error) {
    yield put(getUserFail(error));
  }
}

export function* getUserTagsSaga() {
  try {
    const response = yield call(BffApiService.getUserTags);

    if (response.data.data) {
      yield put(getUserTagsSuccess(response.data.data));
    }
  } catch (error) {
    yield put(getUserTagsError());
  }
}
